export function sortDropdownWithNullDefault (valA, valB) {
	return valB.value === null ? 1 : valA.text.localeCompare(valB.text)
}
